import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Henrique César Madeira
 * id AB5B56A8-CB56-4502-B388-BA02ECEB2D1A
 * name human-male-male
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human-male-male.svg
 * tags
 * - People / Family 
 */
export const HumanMaleMaleIcon = createSvgIcon(<><path d="M7.5,2A2,2 0 0,1 9.5,4A2,2 0 0,1 7.5,6A2,2 0 0,1 5.5,4A2,2 0 0,1 7.5,2M6,7H9A2,2 0 0,1 11,9V14.5H9.5V22H5.5V14.5H4V9A2,2 0 0,1 6,7M16.5,2A2,2 0 0,1 18.5,4A2,2 0 0,1 16.5,6A2,2 0 0,1 14.5,4A2,2 0 0,1 16.5,2M15,7H18A2,2 0 0,1 20,9V14.5H18.5V22H14.5V14.5H13V9A2,2 0 0,1 15,7Z" /></>, 'HumanMaleMaleIcon');
export default HumanMaleMaleIcon